import React, {Component} from 'react';
import {connect} from 'react-redux';
import './TaskGroups.scss'
import classNames from 'classnames';

class TaskGroups extends Component {

  canEdit(taskGroup) {
    return (this.props.getGroupStatus(taskGroup) === 'pending'
      || this.props.getGroupStatus(taskGroup) === 'pending-signature')
      && this.props.canEdit
  }

  canView(taskGroup) {
    return (this.props.getGroupStatus(taskGroup) === 'pending' && !this.props.canEdit)
      || (this.props.getGroupStatus(taskGroup) === 'pending-signature') && !this.props.canEdit
      || (this.props.getGroupStatus(taskGroup) === 'pending-acknowledgement' && !this.props.canAcknowledge)
      || (this.props.getGroupStatus(taskGroup) === 'completed')
  }

  canAcknowledge(taskGroup) {
    return this.props.getGroupStatus(taskGroup) === 'pending-acknowledgement' && this.props.canAcknowledge
  }

  get taskGroups() {
    return this.props.taskGroups && this.props.taskGroups.filter(taskGroup => {
      return taskGroup.phase && taskGroup.phase.name === this.props.phase.header;
    });
  }

  render() {
    return (
      <div className="task-groups">
        {this.taskGroups && this.taskGroups.map(taskGroup => (
          <div className="task-group" key={taskGroup.guid}>
            <div>{taskGroup.name}</div>
            <div className="actions">

              { this.canEdit(taskGroup) &&
                <button className="button secondary small" onClick={() => this.props.onGroupEdit(taskGroup)}>
                  <i className="fa fa-edit" />
                  <span>Edit</span>
                </button>
              }

              { this.canView(taskGroup) &&
                <button className="button small" onClick={() => this.props.onGroupEdit(taskGroup)}>
                  <i className="fa fa-tasks" />
                  <span>View tasks</span>
                </button>
              }

              { this.canAcknowledge(taskGroup) &&
                <button className="button secondary small" onClick={() => this.props.onGroupEdit(taskGroup)}>
                  <i className="fa fa-tasks" />
                  <span>Acknowledge tasks</span>
                </button>
              }

            </div>

            <div className={classNames("task-group-status", this.props.getGroupStatus(taskGroup))}>{this.props.getGroupStatus(taskGroup).replace('-', ' ')}</div>
          </div>
        ))}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    taskGroups: state.tasks.taskGroups
  };
}

export default connect(
  mapStateToProps,
)(TaskGroups);
